<template>
  <div class='User'>
    <search-form size='medium'
                 labelWidth='90px'
                 :searchData="search.searchData"
                 :searchForm="search.searchForm"
                 :searchHandle="search.searchHandle">
    </search-form>

    <Table :TableParam="Table">
      <template v-slot:handle="{ item }">
        <!-- <el-link type="primary"
                 @click="()=>changeItem(item)">修改</el-link> -->
        <el-divider direction="vertical" v-if="_isAdmin"></el-divider>
        <el-link type="primary" v-if="_isAdmin && (!item.admin && !item.superAdmin)" @click="authFun(item.id)">数据权限</el-link>
        <!-- <el-divider direction="vertical"></el-divider> -->
        <!-- <el-link type="danger"
                 @click="removeItem(item)">删除</el-link>
        <el-divider direction="vertical"></el-divider>
        <el-link type="primary"
                 @click="fixPassWord(item)">修改密码</el-link> -->
      </template>
      <template v-slot:Paging>
        <Paging @change="getItemList"
                :pager="pager" />
      </template>
    </Table>

    <service-dialog :show.sync="addDialog.show"
                    @handle="addDialog.confirm"
                    :title="addDialog.title">
      <template v-slot:dialogContent>
        <div class="addfrom">
          <el-form label-position="right"
                   label-width="80px"
                   ref="ruleForm"
                   :rules="addDialog.rules"
                   :model="addDialog.addFrom">
            <el-form-item label="手机号："
                          prop="phoneNo">
              <el-input v-model="addDialog.addFrom.phoneNo"
                        disabled></el-input>
            </el-form-item>
            <el-form-item label="姓名："
                          prop="name">
              <el-input v-model="addDialog.addFrom.name"
                        disabled></el-input>
            </el-form-item>
            <el-form-item label="密码："
                          prop="password"
                          v-if="addDialog.title==='新建'">
              <el-input v-model="addDialog.addFrom.password"
                        disabled></el-input>
            </el-form-item>
            <el-form-item label="邮箱："
                          prop="email">
              <el-input v-model="addDialog.addFrom.email"
                        disabled></el-input>
            </el-form-item>
            <el-form-item label="角色："
                          prop="role">
              <el-select v-model="addDialog.addFrom.role"
                         clearable
                         placeholder="请选择角色">
                <el-option v-for="item in addDialog.roleList"
                           :key="item.id"
                           :label="item.roleName"
                           :value="item.id"></el-option>

              </el-select>
            </el-form-item>

            <el-form-item label="备注：">
              <el-input v-model="addDialog.addFrom.remark"
                        type="textarea"
                        :rows="3"
                        maxlength="100"
                        show-word-limit></el-input>
            </el-form-item>
          </el-form>
        </div>
      </template>
    </service-dialog>

    <service-dialog :show.sync="passwordDialog.show"
                    @handle="passwordDialog.confirm"
                    :title="passwordDialog.title">
      <template v-slot:dialogContent>
        <div class="addfrom">
          <el-form label-position="right"
                   label-width="80px"
                   ref="passwordDialog"
                   :rules="passwordDialog.rules"
                   :model="passwordDialog.from">
            <el-form-item label="密码："
                          prop="password">
              <el-input v-model="passwordDialog.from.password"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </template>
    </service-dialog>
    <!-- 数据权限 -->
    <service-dialog :show.sync="authDialog.show"
                    @handle="authDialog.confirm"
                    :title="authDialog.title">
      <template v-slot:dialogContent>
        <div>
          <el-checkbox v-model="authDialog.isAll" @change="changeAllFun">全部</el-checkbox>
        </div>
        <div style="margin: 20px 22px">
          <el-checkbox-group v-model="authDialog.selects">
            <el-checkbox v-for="item in typeOptions"
                        :label="String(item.id)"
                        :disabled="!!authDialog.isAll" 
                        :key="item.id">{{ item.name }}</el-checkbox>
          </el-checkbox-group>
        </div>
      </template>
    </service-dialog>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import SearchForm from '@/components/SearchForm'
import Table from '@/components/Table'
import Paging from '@/components/Paging'
import serviceDialog from '@/components/Dialog'
import { handleCofirm } from '@/utils'
const intersts = [{ label: '显示离职', value: true }]
const interstProps = { label: 'label', value: 'value' }
const roleProps = { label: 'roleName', value: 'id' }
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    SearchForm,
    Paging,
    Table,
    serviceDialog
  },
  data () {
    // 这里存放数据
    return {
      pager: { // 翻页
        page: 1,
        rows: 10,
        count: 0
      },

      search: { // 搜索
        searchData: {
          status: []
        }, // 返回的数据
        searchForm: [
          { type: 'Input', label: '姓名/手机号：', prop: 'nameOrPhoneNo', placeholder: '请输入姓名/手机号' },
          { type: 'Select', label: '角色：', prop: 'roleId', options: [], props: roleProps, placeholder: '请选择角色' },
          { type: 'Checkbox', prop: 'status', checkboxs: intersts, props: interstProps }
        ],
        searchHandle: [
          { label: '查询', type: 'primary', handle: () => this.searchHandleForm() },
          { label: '重置', handle: () => this.searchResetForm() }
        ]
      },

      Table: { // 表格
        // primaryBtn: {
        //   show: true,
        //   html: '<i class="el-icon-plus"></i>新建',
        //   handle: () => { this.addDialog.show = true; this.addDialog.title = '新建' }
        // },
        handle: true,
        handleWidth: 200,
        data: [],
        column: [
          { prop: 'name', label: '姓名' },
          { prop: 'phoneNo', label: '手机号' },
          { prop: 'email', label: '邮箱' },
          { prop: 'roleName', label: '角色' },
          { prop: 'status', label: '状态' },
          { prop: 'createDate', label: '创建时间' },
          { prop: 'creator', label: '创建人' }
        ]
      },
      addDialog: { // 新建
        show: false,
        title: '新建',
        confirm: this.addDialogConfirm,
        roleList: null,
        addFrom: {
          phoneNo: null,
          name: null,
          password: null,
          email: null,
          role: null,
          remark: null
        },
        rules: {
          phoneNo: [
            { required: true, message: '请输入手机号', trigger: 'blur' },
            { pattern: /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/, message: '手机号不正确', trigger: 'blur' }
          ],
          name: [
            { required: true, message: '请输入姓名', trigger: ['blur'] }
          ],
          password: [
            { required: true, message: '请输入密码', trigger: 'blur' }
          ],
          email: [
            { required: true, message: '请输入email', trigger: 'blur' },
            { pattern: /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/, message: 'email格式不正确', trigger: 'blur' }
          ],
          role: [
            { required: true, message: '请选择角色', trigger: ['change', 'blur'] }
          ]
        }
      },

      passwordDialog: {
        show: false,
        title: '修改密码',
        confirm: this.updatePassword,
        rules: {
          password: [
            { required: true, message: '请输入密码', trigger: 'blur' }
          ]
        },
        from: {}
      },
      authDialog: {
        show: false,
        title: '账户类型选择',
        selects: [],
        isAll: false,
        confirm: this.authConfirmFun
      },
      typeOptions: [],
    }
  },
  // 监听属性 类似于data概念
  computed: {
    _isAdmin () {
      const userInfoVO = JSON.parse(localStorage.getItem('userInfo') || '{}')?.userInfoVO
      return userInfoVO && (userInfoVO.admin || userInfoVO.superAdmin)
    }
  },
  // 监控data中的数据变化
  watch: {
    'addDialog.show': {
      handler (to) {
        if (!to) {
          this.$refs.ruleForm.resetFields()
          this.addDialog.addFrom = {
            phoneNo: null,
            name: null,
            password: null,
            email: null,
            role: null,
            remark: null
          }
        }
      }
    }

  },
  // 方法集合
  methods: {
    // 查询
    searchHandleForm () {
      this.getItemList()
    },
    // 重置
    searchResetForm () {
      this.search.searchData = {
        status: []
      }
    },
    // 修改密码行
    fixPassWord (row) {
      this.passwordDialog.id = row.id
      this.passwordDialog.show = true
    },
    removeItem (row) { // 删除行
      handleCofirm('确定要删除该行嘛?', 'type')
        .then(async () => {
          this.deleteUser(row.id)
        })
        .catch(() => { })
    },

    async changeItem (row) { // 修改行
      await this.getUserInfo(row.id)
      this.addDialog.title = '编辑'
      this.addDialog.show = true
    },
    // 添加 / 编辑 dialog确定按钮
    addDialogConfirm () {
      const { title } = this.addDialog
      const { phoneNo, name, password, email, role, remark, id } = this.addDialog.addFrom
      const params = {
        phoneNo,
        name,
        email,
        roleIds: [role],
        remark
      }
      if (title === '新建') {
        params.password = password
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            this.addUser(params)
          } else {
            return false
          }
        })
      } else if (title === '编辑') {
        params.id = id
        this.changeUser(params)
        this.addDialog.show = false
      }
    },

    // 添加接口
    addUser (params) {
      this.$http.addUser(params)
        .then((res) => {
          if (res.status === 200) {
            this.$message.success(res.msg)
            this.addDialog.show = false
            this.getItemList()
          } else {
            this.$message.error(res.msg)
          }
        })
    },

    // 修改接口
    changeUser (params) {
      this.$http.changeUser(params)
        .then((res) => {
          if (res.status === 200) {
            this.$message.success(res.msg)
            this.getItemList()
          } else {
            this.$message.error(res.msg)
          }
        })
    },

    // 删除接口
    deleteUser (id) {
      const params = {
        id
      }
      this.$http.deleteUser(params)
        .then((res) => {
          if (res.status === 200) {
            this.$message.success(res.msg)
            this.getItemList()
          } else {
            this.$message.error(res.msg)
          }
        })
    },

    // 修改密码
    updatePassword (id) {
      const params = {
        id: this.passwordDialog.id,
        password: this.passwordDialog.from.password
      }
      this.$http.updatePassword(params)
        .then((res) => {
          if (res.status === 200) {
            this.$message.success(res.msg)
          } else {
            this.$message.error(res.msg)
          }
        })
    },

    // 查询单条信息
    async getUserInfo (id) {
      const { addDialog } = this
      const params = {
        id
      }
      await this.$http.getUserInfo(params)
        .then((res) => {
          if (res.status === 200) {
            addDialog.addFrom = {
              id: res.data.id,
              phoneNo: res.data.phoneNo,
              name: res.data.name,
              password: res.data.password,
              email: res.data.email,
              role: res.data.roles ? res.data.roles[0].id : null,
              remark: res.data.remark
            }
          }
        })
    },

    // 获取角色列表
    getRoleList () {
      this.$http.getRoleList()
        .then((res) => {
          if (res.status === 200) {
            this.addDialog.roleList = res.data
            this.search.searchForm.forEach((item) => {
              if (item.label && item.label.includes('角色')) {
                item.options = res.data
              }
            })
          }
        })
    },

    getItemList () {
      const { pager, search, Table } = this
      const status = search.searchData.status[0] || false
      const params = {
        pageNum: pager.page,
        pageSize: pager.rows,
        ...search.searchData,
        status
      }
      this.$http.getUserPage(params)
        .then((res) => {
          if (res.status === 200) {
            pager.count = res.data.total
            Table.data = res.data.list.map(item => ({
              ...item,
              status: item.status ? '离职' : '在职',
              roleName: item.roles.length ? item.roles[0].roleName : null
            }))
          }
        })
    },
    // 账户类型
    async getCardTypeList () {
      const res = await this.$http.getCardTypeList()
      if(res && res.status === 200) {
        this.typeOptions = res.data
      }
    },
    // 数据权限
    authFun (id) {
      this.$http.getUserInfo({ id }).then(res => {
        const { id, aclCardType } = res.data
        this.authDialog.isAll = aclCardType === '0' // 全部
        this.authDialog.selects = aclCardType != 0 ? aclCardType.split(',') : []
        this.authDialog.id = id
        this.authDialog.show = true
      })
    },
    // 保存数据权限的配置
    authConfirmFun () {
      const { isAll, id, selects } = this.authDialog
      const data = {
        id,
        acl: isAll ? 0 : !selects.length ? '' : selects.join(',')
      }
      this.$http.updateDataAuthApi(data).then(res => {
        if(res.status === 200) {
          this.$message.success(res.msg)
          this.getItemList()
          this.authDialog.show = false
        }
      })
    },
    // 选择全部时候需要取消其他选择
    changeAllFun (e) {
      if(e) {
        this.authDialog.selects = []
      }
    },
    init () {
      this.getCardTypeList()
      this.getItemList()
      this.getRoleList()
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    this.init()
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {

  },
  beforeCreate () { }, // 生命周期 - 创建之前
  beforeMount () { }, // 生命周期 - 挂载之前
  beforeUpdate () { }, // 生命周期 - 更新之前
  updated () { }, // 生命周期 - 更新之后
  beforeDestroy () { }, // 生命周期 - 销毁之前
  destroyed () { }, // 生命周期 - 销毁完成
  activated () { } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.addfrom {
  padding: 0 60px;
}
</style>
